import { create } from 'zustand';
import { ApiUtils, type Product, ProductApi, RequestStrategyEnum } from '@shared/api';

interface UseProductsStore {
  loading: boolean;
  data: Product[];
  error: string | null;
  getProducts: (signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useProductsStore = create<UseProductsStore>((set) => ({
  loading: false,
  data: [],
  error: null,

  getProducts: ApiUtils.wrapperApi(async (signal) => {
    try {
      set({ loading: true, error: null });
      const result = await ProductApi.getProducts(signal);
      set({ loading: false, data: result || [] });
    } catch (error) {
      set({ loading: false, error: ApiUtils.getApiError(error) });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ loading: false, data: [], error: null }),
}));
